import { render } from "./PinLayer.vue?vue&type=template&id=4510c475"
import script from "./PinLayer.vue?vue&type=script&lang=ts"
export * from "./PinLayer.vue?vue&type=script&lang=ts"
script.render = render

export default script